import React from "react"
import { useTranslation } from "react-i18next"

const G2ReviewWall = () => {
  const { t } = useTranslation()

  // Get the review quotes from home translations
  const quotes = t("home.g2-review-quotes", { returnObjects: true })

  // Create repeated quotes array for all rows
  const repeatedQuotes = []

  for (let i = 0; i < 20; i++) {
    repeatedQuotes.push(...quotes)
  }

  // Create offset arrays for each row to show different content
  const quotesLength = quotes.length
  const row1Quotes = [...repeatedQuotes] // Start from beginning
  const row2Quotes = [
    ...repeatedQuotes.slice(Math.floor(quotesLength / 3)),
    ...repeatedQuotes.slice(0, Math.floor(quotesLength / 3)),
  ] // Start from 1/3 through
  const row3Quotes = [
    ...repeatedQuotes.slice(Math.floor((quotesLength * 2) / 3)),
    ...repeatedQuotes.slice(0, Math.floor((quotesLength * 2) / 3)),
  ] // Start from 2/3 through

  return (
    <div className="container-fluid">
      <h3 className="center-xs">{t("home.g2-review-wall-title")}</h3>
      <div className={`g2-review-wall`}>
        <div className="g2-review-wall__row g2-review-wall__row--1">
          <div className="g2-review-wall__track">
            {row1Quotes.map((quote, index) => (
              <div key={`row1-${index}`} className="g2-review-wall__brick">
                <span className="g2-review-wall__quote">"{quote}"</span>
              </div>
            ))}
          </div>
        </div>

        <div className="g2-review-wall__row g2-review-wall__row--2">
          <div className="g2-review-wall__track">
            {row2Quotes.map((quote, index) => (
              <div key={`row2-${index}`} className="g2-review-wall__brick">
                <span className="g2-review-wall__quote">"{quote}"</span>
              </div>
            ))}
          </div>
        </div>

        <div className="g2-review-wall__row g2-review-wall__row--3">
          <div className="g2-review-wall__track">
            {row3Quotes.map((quote, index) => (
              <div key={`row3-${index}`} className="g2-review-wall__brick">
                <span className="g2-review-wall__quote">"{quote}"</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default G2ReviewWall
